import { thor } from "../../typings/thor";

export interface MaintenanceData {
    status: "future" | "present" | null;
    timestamp: number;
    message: string;
}

class MaintenanceRun {
    public static $inject: string[] = [
        "$interval",
        "maintenanceService"
    ];

    constructor(
        $interval: ng.IIntervalService,
        maintenanceService
    ) {
        $interval(
            () => {
                maintenanceService.fetchMaintenanceJson();
            },
            6000
        );

    }
}

class MaintenanceService {
    public static $inject: string[] = [
        "$http",
        "$interval",
        "$location",
        "$state",
        "toaster"
    ];

    public data: MaintenanceData;
    public fetchResponse: ng.IHttpPromise<MaintenanceData>;

    private $http;
    private $location;
    private $state;
    private toaster;

    constructor(
        $http: ng.IHttpService,
        $interval: ng.IIntervalService,
        $location: ng.ILocationService,
        $state: ng.ui.IStateService,
        toaster
    ) {
        this.$http = $http;
        this.$location = $location;
        this.$state = $state;
        this.toaster = toaster;

        this.fetchResponse = this.$http.get(
            `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/maintenance.json`
        )
            .catch(angular.noop);
    }

    public fetchMaintenanceJson() {
        this.$http.get(
            `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/maintenance.json`
        )
            .then(res => {
                if (res && !angular.equals(this.data, res.data)) {
                    this.data = <MaintenanceData>res.data;
                    switch (this.data.status) {
                        case "future":
                            if (this._getLastMaintenanceTimestamp() < this.data.timestamp) {
                                this.toaster.toast(<thor.ToasterParameter>{
                                    position: "top right",
                                    message: this.data.message,
                                    warn: true,
                                    delay: 0
                                })
                                    .then(() => {
                                        localStorage.setItem(
                                            "lastMaintenanceTimestamp",
                                            "" + this.data.timestamp
                                        );
                                    });
                            }
                            break;
                        case "present":
                            if (this.$state.current.name !== "maintenance") {
                                window.location.replace(
                                    this.$location.protocol() + "://" + this.$location.host() +
                                    ":" + this.$location.port() + "/maintenance"
                                );
                            }
                            break;
                        default:
                            if (this.$state.current.name === "maintenance") {
                                window.location.replace(
                                    this.$location.protocol() + "://" + this.$location.host() +
                                    ":" + this.$location.port()
                                );
                            }
                            break;
                    }
                }
            })
            .catch(angular.noop);
    }

    private _getLastMaintenanceTimestamp() {
        const lastMaintenanceTimestamp = localStorage.getItem("lastMaintenanceTimestamp");
        return lastMaintenanceTimestamp ? parseInt(lastMaintenanceTimestamp, 10) : 0;
    }
}

angular
    .module("thor.core.maintenance.run", [])
    .run(MaintenanceRun)
    .service("maintenanceService", MaintenanceService);
